<template>
    <div class="calculator__range-item">
        <div class="calculator__range-item-wrap">
            <div class="calculator__range-item-title">{{title}}</div>
            <div class="calculator__range-item-data">
                    <div class="calculator__range-item-data-range_selector">
                        <div class="calculator__range-item-data-range_selector-plus">
                            <i class="mdi mdi-plus" @click="plusRange"></i>
                        </div>
                        <div class="calculator__range-item-data-range_selector-start">
                            {{getFormatData}} {{metric}}
                        </div>
                        <div class="calculator__range-item-data-range_selector-minus">
                            <i class="mdi mdi-minus" @click="minusRange"></i>
                        </div>
                    </div>
                    <div class="calculator__range-item-data-rangebar">
                        <input type="range" :min="minRange" :max="maxRange" :step="stepRange" @input="dataSet" :value="data">
                    </div>
                    <div class="calculator__range-item-data-range">
                        <div class="calculator__range-item-data-range-start">{{(minRange).toLocaleString('en')}}</div>
                        <div class="calculator__range-item-data-range-midle"></div>
                        <div class="calculator__range-item-data-range-end">{{(maxRange).toLocaleString('en')}}</div>
                    </div>
            </div>
        </div>
    </div>  
</template>
<script>
export default {
    props : {
        title:{default:'Title'},
        minRange:{default:0},
        maxRange:{default:100},
        stepRange:{default:10},
        defaultValue:{default:0},
        metric:{default:''}
    },
    data() {
        return {
            data:0
        }
    },
    methods : {
        plusRange() {
            if(this.data < this.maxRange)
            {
            let getDataInt = parseInt(this.data);
            let getStepInt = parseInt(this.stepRange);
            this.data = getDataInt + getStepInt
            this.$emit('getData',this.data)
            }
        },

        minusRange() {
            if(this.data > this.minRange)
            this.data-=this.stepRange;
            this.$emit('getData',this.data)
        },
        dataSet(event) {
            this.data = event.target.value
			this.$emit('getData', event.target.value)
        },
        targetSet(e) {
            this.data = e
        }
    },
    computed: {
        getFormatData() {
            let format = Math.ceil(this.data)
           return format.toLocaleString('en')
        }
    },
    mounted() {
        this.data = this.minRange;
    }


}
</script>
<style lang="less" scoped>
.calculator__range-item {
    width: 284px;
    display: block;

    &-wrap {
        border-radius: 4px;
        background-color: #3d536b;
        padding: 1px;
        box-sizing: border-box;
    }

    &-title {
        font-family: Montserrat;
        font-size: 14px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 3.43;
        letter-spacing: 0.4px;
        text-align: center;
        color: #adc7e1;
        text-transform: uppercase;
    }

    &-data {
        border-radius: 4px;
        background-color: #293546;
        width: 100%;

        &-range_selector {
            font-family: Montserrat;
            font-size: 24px;
            line-height: 3;
            letter-spacing: 0.3px;
            color: #718da8;
            display: flex;
            justify-content: space-between;
            max-height: 64px;

            &-plus {
                padding-left: 24px;
            }

            &-minus {
                padding-right: 24px;
            }

            &-start {
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                text-align: center;
                color: #00ffd0;
            }
        }

        &-rangebar
                {
                    input[type=range] 
                    {
                        -webkit-appearance: none;
                        width: 100%;
                    }
                    
                    input[type=range]:focus 
                    {
                        outline: none;
                    }
                    
                    input[type=range]::-webkit-slider-runnable-track 
                    {
                        width: 100%;
                        height: 4px;
                        cursor: pointer;
                        background: #3d536b;
                    }
                    
                    input[type=range]::-webkit-slider-thumb 
                    {
                        height: 20px;
                        width: 20px;
                        border-radius: 20px;
                        background-color: #718da8;
                        cursor: pointer;
                        -webkit-appearance: none;
                        margin-top: -8px;
                    }
                    
                    input[type=range]:hover::-webkit-slider-thumb 
                    {
                        background: #fff;
                    }
                    
                    input[type=range]::-moz-range-track 
                    {
                        width: 100%;
                        height: 4px;
                        cursor: pointer;
                        background: #3d536b;
                    }
                    
                    input[type=range]::-moz-range-thumb
                    {
                        height: 20px;
                        width: 20px;
                        border-radius: 20px;
                        background-color: #718da8;
                        cursor: pointer;
                        -webkit-appearance: none;
                        border: none;
                    }
                    
                    input[type=range]:hover::-moz-range-thumb 
                    {
                        background: #fff;
                    }
                    
                    input[type=range]::-ms-track 
                    {
                        width: 100%;
                        height: 4px;
                        cursor: pointer;
                        background: #3d536b;
                    }
                    
                    input[type=range]::-ms-thumb 
                    {
                        height: 20px;
                        width: 20px;
                        border-radius: 20px;
                        background-color: #718da8;
                        cursor: pointer;
                        -webkit-appearance: none;
                        border: none;
                    }
                    
                }
                &-range
                {
                    font-family: Arimo;
                    font-size: 11px;
                    font-weight: bold;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 3.6;
                    letter-spacing: 0.4px;
                    text-transform: uppercase;
                    color: #adc7e1;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 12px;
                    max-height: 40px;
                    
                    &-midle
                    {
                        color:#00ffd0;
                    }
                }
    }
}
</style>
